import { cn } from "@/lib/utils";
import { LABELS } from "@/utils/constants/appConstants/commonConstants";

type TransferOwnershipButtonProps = {
    id?: string;
    iconId?: string;
    onClick: () => void;
    className?: string;
};

function TransferOwnershipButton({ id, iconId, onClick, className }: TransferOwnershipButtonProps) {
    return (
        <button
            type="button"
            id={id}
            className={cn("gs-transfer-ownership-btn", className)}
            onClick={onClick}
            aria-label={LABELS.TRANSFER_OWNERSHIP}
            title={LABELS.TRANSFER_OWNERSHIP}
        >
            <span className="gs-transfer-ownership-btn__icons" id={iconId} aria-hidden>
                <em className="icon ni ni-file" />
                <em className="icon ni ni-arrow-long-right gs-transfer-ownership-btn__arrow" />
                <em className="icon ni ni-user" />
            </span>
            <span className="gs-transfer-ownership-btn__label">{LABELS.TRANSFER_OWNERSHIP}</span>
        </button>
    );
}

export default TransferOwnershipButton;
